import { Flex, IconFont, Input, pointer } from '@byecode/ui'
import type { FlowNode } from '@lighthouse/shared'
import { findNodeOption, getFlowNodeIcon, nodeTypeOptions, triggerNodeTypeOptions } from '@lighthouse/shared'
import React, { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

const SCxWrapper = styled.div`
    padding: 16px 16px 8px 16px;
    width: 100%;
    position: sticky;
    z-index: 99;
    top: 0;
    border-radius: 12px 12px 0 0;
    background-color: var(--color-white);
`

const SCxContainer = styled.div`
    height: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const SCxTitleBox = styled.div`
    flex: 1;
    font-size: 16px;
    font-weight: 600;
    overflow: hidden;
    padding-right: 28px;
    color: var(--color-black);
`

const SCxTitle = styled.div`
    width: fit-content;
    max-width: 100%;
    position: relative;
`

const SCxInput = styled(Input)`
    outline: none;
    border: none;
    background: transparent;
    height: 24px;
    line-height: 24px;
    &:not([data-focused]):hover {
        background: transparent;
    }
`

const SXcDescInput = styled(Input)`
    font-size: 12px;
    color: var(--color-gray-500);
    outline: none;
    height: 20px;
    line-height: 20px;
    border: none;
    background: transparent;
    margin-top: 8px;
    input {
        padding-left: 0;
    }
    /* &:hover {
        background: transparent;
    } */
    &:not([data-focused]):hover {
        background: transparent;
    }
    &:focus {
        background: transparent;
    }
    &:placeholder {
        font-size: 12px;
        color: var(--color-gray-500);
    }
`

const SCxClose = styled(IconFont)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: rgba(236, 239, 244, 1);
    border-radius: 50%;
    ${pointer}
`

const SCxLogo = styled.div<{ background?: string }>`
    width: 24px;
    height: 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ background }) => background || '#2E90FA'};
`

const SCxIcon = styled(IconFont)<{ color?: string }>`
    font-size: 24px;
    color: ${({ color }) => color || 'var(--color-white)'};
`

const SCxLeftName = styled.div`
    display: flex;
    align-items: center;
    /* gap: 8px; */
`

interface NodeHeaderProps {
    disable?: boolean
    rightSection?: React.ReactNode
    onClose?: () => void
    node: FlowNode
}

type Mode = 'edit' | 'preview'

export const NodeHeader: React.FC<NodeHeaderProps> = ({ disable = false, rightSection, onClose, node }) => {
    const { control } = useFormContext()

    const currentIcon = useMemo(() => {
        const triggerOptions = new Set(triggerNodeTypeOptions.map(item => item.value))
        const options = nodeTypeOptions.filter(item => !triggerOptions.has(item.value)) // 触发节点的icon外层列表要用到，不动

        const foundOption = findNodeOption(node.data, options)
        const icon = getFlowNodeIcon(node.data)
        return { ...foundOption, icon }
    }, [node.data])

    return (
        <SCxWrapper>
            <SCxContainer>
                <SCxTitleBox>
                    <SCxLeftName>
                        {/* <SCxIcon type="Close" onClick={onClose} size="24" /> */}
                        <SCxLogo background={currentIcon?.background}>
                            <SCxIcon size={16} type={currentIcon?.icon || 'HomeLiner'} color={currentIcon?.color} />
                        </SCxLogo>
                        <Controller
                            name="name"
                            control={control}
                            render={({ field }) => <SCxInput size="sm" value={field.value} onChange={field.onChange} />}
                        />
                    </SCxLeftName>
                </SCxTitleBox>
                <Flex gap={8}>
                    {rightSection}
                    <SCxClose type="Close" color="var(--color-gray-400)" onClick={onClose} />
                </Flex>
                {/* <SCxClose>
                    <SCxIcon type="Close" onClick={onClose} />
                </SCxClose> */}
            </SCxContainer>
            <Controller
                name="description"
                control={control}
                render={({ field }) => <SXcDescInput size="sm" value={field.value} onChange={field.onChange} placeholder="添加描述..." />}
            />
        </SCxWrapper>
    )
}
